var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOntrac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#20376C",
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 243.7s95-92.2 257.8-58.3l-128.9 40.5S127.1 210.8 81 243.7z",
    fill: "#F6D614"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4 297.4s55.5-84.7 160.9-63v43.3c0-.1-65.8-43.4-160.9 19.7zm310.5-106.3l-138.3 44.2-.9 48.9 118.5 49.9 137.4-55.5v-49l-116.7-38.5z",
    fill: "#F6D614"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.7 319.9l-101.6-42.3v-31l101.6 38.5v34.8zm-86.6-81.8l116.7-37.6 94.1 31-115.8 46.1-95-39.5zm97.9 81.8v-33.8l122.3-44.2.9 31-123.2 47z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.4 229.7c.3.8-.1 1.7-.9 2l-27.6 10c-.8.3-1.7-.1-2-.9-.3-.8.1-1.7.9-2l27.6-10c.8-.4 1.7.1 2 .9zm6.6 3.4c.3.8-.1 1.7-.9 2l-27.6 10c-.8.3-1.7-.1-2-.9-.3-.8.1-1.7.9-2l27.6-10c.8-.3 1.7.1 2 .9zm67.9-3.1c.4 1-.1 2.1-1.1 2.4l-33.1 12c-1 .4-2.1-.1-2.4-1.1-.4-1 .1-2.1 1.1-2.4l33.1-12.1c.9-.3 2 .2 2.4 1.2zm-11.3-3.8c.4 1-.1 2.1-1.1 2.4l-33.1 12.1c-1 .4-2.1-.1-2.4-1.1-.4-1 .1-2.1 1.1-2.4l33.1-12.1c.9-.4 2 .1 2.4 1.1zm21.9 8.8c.4 1-.1 2.1-1.1 2.4l-33.1 12.1c-1 .4-2.1-.1-2.4-1.1-.4-1 .1-2.1 1.1-2.4l33.1-12.1c1-.4 2.1.1 2.4 1.1z",
    fill: "#213E7B"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOntrac);
export default __webpack_public_path__ + "static/media/ontrac.00ff97a3877adcb78ac27d92059801ac.svg";
export { ForwardRef as ReactComponent };